import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getLevelUpInfo, ILevelUpInfoItem } from "../services/serviceProviders";

export const useLevelUpInfo = () => {
  const { data: levelUpInfo, isLoading, isError, isSuccess } = useDataQuery<ILevelUpInfoItem[]>(
    ["levelUpInfo"],
    () => getLevelUpInfo().then(({ data }) => data)
  );

  return { levelUpInfo, isLoading, isError, isSuccess };
};
